/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarygoing1Inputs */

const en_summarygoing1 = /** @type {(inputs: Summarygoing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Going`)
};

const de_summarygoing1 = /** @type {(inputs: Summarygoing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bin dabei`)
};

/**
* | output |
* | --- |
* | "Going" |
*
* @param {Summarygoing1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarygoing1 = /** @type {((inputs?: Summarygoing1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarygoing1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarygoing1(inputs)
	return de_summarygoing1(inputs)
});
export { summarygoing1 as "summaryGoing" }